import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/logo.png'
import _imports_1 from '../images/cancel.png'


const _withScopeId = n => (_pushScopeId("data-v-158a6326"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cookie-box"
}
const _hoisted_2 = { class: "cookie-con" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-con" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "cookie-logo",
    src: _imports_0,
    alt: "otimes logo"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cookie-title" }, "Cookie preferences", -1))
const _hoisted_5 = { class: "cookie-text" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Our website uses cookies. Some or them are needed for the website to unction properly while others help us to improve the website to meet your needs. You will find further information in our")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Accept all")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Only accept essential cookies")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cookie-subtitle" }, "ESSENTIAL", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cookie-text" }, "These cookies cannot be deactivated as thev are required for basic functions to keeo the weosite running properly.", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cookie-subtitle" }, "ADDITIONAL COOKIES", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "cookie-text" }, "These cookies enable us to analyse the use of the website and to improve its qually and content Thev also helo to provide additional usetul tunctions and external content. Disabling these cookies mav result in some content or features becomina unusable. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.cookieTag == 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("img", {
            class: "close",
            src: _imports_1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cookieTag = 0)),
            alt: "Cookie preferences closed"
          }),
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/cookie')))
            }, " privacy policy.")
          ]),
          _createVNode(_component_el_button, {
            class: "cookie-button",
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cookieTag = 0,_ctx.setCookie()))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "cookie-button",
            plain: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cookieTag = 0,_ctx.setCookie()))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12
        ])
      ]))
    : _createCommentVNode("", true)
}